import React from "react";

const LmLoader = () => (
    <div className="lm-loader" aria-label="Loading">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
);

export default LmLoader;
